export enum CommonAppStates {
waitingForAction = 0,
checkingValidation = 1,
awaitingConfirm = 2,
acceptedConfirm = 3,
checkingToSave = 4
}
